// extracted by mini-css-extract-plugin
module.exports = {"notifications":"styles_notifications__uLqNd","notification":"styles_notification__jUm5Y"};